// extracted by mini-css-extract-plugin
export default {"container":"Imagem_container__5YQ7i","imagem":"Imagem_imagem__3oGoP","info":"Imagem_info__XHSr6","descricao":"Imagem_descricao__+YoVJ","opcoes":"Imagem_opcoes__2rqmN"};